{
  "(optional)": "(opcjonalne)",
  "(required)": "(wymagane)"
}